export default __webpack_public_path__ + "static/media/xrp-logo.f9dbdf1f.svg";